export const TaskSharedResultsTypes = {
  ADD_TASK_SHARED_RESULTS: "ADD_TASK_SHARED_RESULTS",
  ADD_TASK_SHARED_RESULTS_SUCCESS: "ADD_TASK_SHARED_RESULTS_SUCCESS",
  ADD_TASK_SHARED_RESULTS_FAILURE: "ADD_TASK_SHARED_RESULTS_FAILURE",
  CLEAR_FORM_ERRORS: "CLEAR_FORM_ERRORS",
  FETCH_TASK_SHARED_RESULTS: "FETCH_TASK_SHARED_RESULTS",
  FETCH_TASK_SHARED_RESULTS_SUCCESS: "FETCH_TASK_SHARED_RESULTS_SUCCESS",
};
